import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var DeleteSecretInputClass;
function DeleteSecretInput() {
  if (DeleteSecretInputClass === VOID) {
    class $ {
      constructor(partyId, secretId) {
        this.x6s_1 = partyId;
        this.y6s_1 = secretId;
      }
      toString() {
        return 'DeleteSecretInput(partyId=' + this.x6s_1.toString() + ', secretId=' + this.y6s_1.toString() + ')';
      }
      hashCode() {
        var result = this.x6s_1.hashCode();
        result = imul(result, 31) + this.y6s_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DeleteSecretInput()))
          return false;
        if (!this.x6s_1.equals(other.x6s_1))
          return false;
        if (!this.y6s_1.equals(other.y6s_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'DeleteSecretInput');
    DeleteSecretInputClass = $;
  }
  return DeleteSecretInputClass;
}
//region block: exports
export {
  DeleteSecretInput as DeleteSecretInput42tzeavgre6q,
};
//endregion

//# sourceMappingURL=DeleteSecretInput.mjs.map
